import {
	BalanceLimitExceededRealTimeMessagePayload,
	DepositLimitReachedRealTimeMessagePayload,
} from "@obg/common.realtime-notifications";

export interface KsaLimitsAlertContent {
	title: string;
	icon: string;
	message: string;
	amountTitle?: string;
	amountValue?: string;
	limitType?: string;
	footer: string;
}

export interface KsaLimitsAlertContainerInputData {
	payload?: DepositLimitReachedRealTimeMessagePayload | BalanceLimitExceededRealTimeMessagePayload;
	ksaLimitAlertType: KsaLimitAlertType;
}

export enum KsaLimitAlertType {
	DepositLimit,
	BalanceLimit,
	SessionLimit,
}
